module.exports = __webpack_public_path__ + "static/media/IMG-20191012-WA0000.663da614.jpg";